import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import PropTypes from "prop-types";
import { fetchTermsAndPrivacy } from "./services";

export default function PrivacyAndPolicies({ handleDialog, open }) {
  const [policies, setPolicies] = useState([]);
  useEffect(() => {
    fetchTermsAndPrivacy().then(({ data }) => {
      const onboardingPolicies = data.data.policies.filter(
        ({ policyTypeId }) => policyTypeId === 1 || policyTypeId === 3
      );
      setPolicies(onboardingPolicies);
    });
  }, []);

  return (
    <div>
      <Dialog
        open={open}
        maxWidth="lg"
        onClose={handleDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div style={{ textAlign: "justify", color: "black" }}>
              {policies?.map((policy) => (
                <div
                  className="ck-content"
                  id={policy.policyType.replaceAll(" ", "")}
                  key={`${policy.policyTypeId}-${policy.version}`}
                >
                  <div dangerouslySetInnerHTML={{ __html: policy.body }} />
                </div>
              ))}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialog} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
PrivacyAndPolicies.propTypes = {
  open: PropTypes.bool,
  handleDialog: PropTypes.func.isRequired,
};
PrivacyAndPolicies.defaultProps = {
  open: null,
};
